import styles from './dashboard-header.module.css';
export function DashboardHeader({ slots }) {
  return (
    <header className={styles.header}>
      <div className={styles.brand}>{slots?.leftArea}</div>
      <div className={styles.navigation}>{slots?.centerArea}</div>
      <div className={styles.actions}>{slots?.rightArea}</div>
    </header>
  );
}
